import React, { useEffect } from 'react'
import { TwitterTimelineEmbed } from 'react-twitter-embed'

const getTwitterScreenNameByUrl = (url: string) => {
  if (!url) {
    return
  }
  const matches = url.match(/http(s)*:\/\/(www.)*twitter.com\/([^/]+)/)
  if (!matches) {
    return
  }
  return matches[matches.length - 1]
}

interface ITwitterPostsProps {
  url: string
  onLoadSuccess: () => void
}

const TwitterPosts: React.FC<ITwitterPostsProps> = ({ url, onLoadSuccess }) => {
  const screenName = getTwitterScreenNameByUrl(url)
  if (!screenName) {
    return null
  }
  useEffect(() => {
    onLoadSuccess()
  }, [])
  return (
    <TwitterTimelineEmbed
      sourceType="profile"
      screenName={screenName}
      options={{ width: 320, height: '100%' }}
      noFooter
      noHeader
    />
  )
}

export { TwitterPosts, getTwitterScreenNameByUrl }
